import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import locations from './modules/locations'
import tableFilters from './modules/tableFilters'
import users from './modules/users'
import msalConfig from './modules/msalConfig'
import holidays from './modules/holidays'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		app,
		locations,
		appConfig,
		verticalMenu,
		tableFilters,
		msalConfig,
		holidays,
		users
	},
	actions: {

	},

	strict: process.env.DEV,
})

